
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { CountrySelectionService } from './country-selection.service';

@Injectable({
  providedIn: 'root'
})
export class ServiceProviderService {

  constructor(private http: HttpClient, private countrySelectionService: CountrySelectionService) { }

  getServiceProviders(): Observable<any[]> {
    return this.countrySelectionService.selectedCountry$.pipe(
      switchMap(country => {
        const apiUrl = this.countrySelectionService.getApiUrl('srh_service_provider_listing', country);
        return this.http.get<any[]>(apiUrl);
      })
    );
  }
}
